module.exports = __webpack_public_path__ + "Icono_HistorialMaterial_512.png";